// extracted by mini-css-extract-plugin
export default {"goal-card":"GoalCard_goal-card__9G4q1","icon":"GoalCard_icon__-kZ+3","description":"GoalCard_description__oGlsU"};